export default __webpack_public_path__ + "static/dejavu_z9-4f7bd4720dd66bbbdf84d5d2b489301b.png";